import { ofType } from "redux-observable";
import { from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionSellProduct } from "../../trade-component/actionTrade";
import { TypeActionQuickSell } from "../actionQuickSell";
export var epicQuickSellResourceSell = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionQuickSell.Sell), switchMap(function (action) {
        return from([
            actionModalClose(IdModal.QuickSell),
            actionSellProduct(action.itemId, action.amount),
        ]);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/quick-sell-dialog/epics/epicQuickSellResourceSell.ts
// module id = 2111
// module chunks = 3